import { combineReducers } from 'redux';

import loading from './loading';
import account from './account';
import admin from './admin';
import common from "./common";

const rootReducer = combineReducers({
    loading,
    account,
    admin,
    common,
});
export default rootReducer;